import { message } from "antd";
import qs from "qs";

import {
  GET_RECOVERIES_REQUEST,
  GET_RECOVERIES_SUCCESS,
  GET_RECOVERIES_FAILURE,
} from "../../constants/actionTypes";
import { axios } from "../../constants/axiosConfig";

const icmsModule = JSON.parse(sessionStorage.getItem("icmsModule"));
const BASE_URL = icmsModule
? process.env.REACT_APP_APICLOUD_URL_ICMS
: process.env.REACT_APP_APICLOUD_URL;

// Buscar todas as recuperações
export function getRecoveries(params) {
  return async (dispatch) => {
    dispatch({ type: GET_RECOVERIES_REQUEST });
    await axios
      .get("apuracao/resultados/apurados", {
        params,
        paramsSerializer: (params) => {
          const pagination = qs.stringify(params.pagination);
          const filter = qs.stringify(params.filter, { delimiter: "|" });
          return `${pagination}&filter=${filter}`;
        },
      })
      .then((response) => {
        dispatch({ type: GET_RECOVERIES_SUCCESS, payload: response.data });
      })
      .catch(() => {
        dispatch({ type: GET_RECOVERIES_FAILURE });
      });
  };
}

// Download relatório recuperações
export function downloadRecoveries(isPdf) {
  return (dispatch) => {
    dispatch({ type: "DOWNLOAD_REPORT_REQUEST" });

    fetch(`${BASE_URL}/apuracao/resultados/apurados/relatorio?isPDF=${isPdf}`, {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${sessionStorage.getItem("eRecuperadorJwt")}`,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          let fileName = "";
          if (isPdf) {
            fileName = icmsModule
              ? "SEGREGACAO DE RECEITAS - PIS COFINS E ICMS - PDF.zip"
              : "APURAÇÃO DE CRÉDITO - PIS COFINS - PDF.zip";
          } else {
            fileName = icmsModule
              ? "SEGREGACAO DE RECEITAS - PIS COFINS E ICMS - EXCEL.zip"
              : "APURAÇÃO DE CRÉDITO - PIS COFINS - EXCEL.zip";
          }

          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const downloadLink = document.createElement("a");
            downloadLink.href = url;
            downloadLink.download = fileName;
            downloadLink.click();
            /* inserido o reload abaixo como forma paliativa para não gerar o loop de requisições - Leonardo (16/09) */
            //window.location.reload();
          });

          dispatch({ type: "DOWNLOAD_REPORT_SUCCESS" });
        } else {
          message.error("Não foi possível gerar o relatório");
          dispatch({ type: "DOWNLOAD_REPORT_FAILURE" });
        }
      })
      .catch(() => {
        message.error("Não foi possível gerar o relatório");
        dispatch({ type: "DOWNLOAD_REPORT_FAILURE" });
      });
  };
}
